module.exports = __webpack_public_path__ + "img/jindu.03588399.png";